/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Components from "app/components";
import { URL_TEACHER_MAIN_NEW_ABOUT } from "app/mock/page_urls";

const DashboardNew: FC = () => {
  const components = Components.section.teacher.home.dashboardNew;
  return (
    <Routes>
      <Route
        element={
          <>
            <h1>header</h1>
            <Outlet />
          </>
        }
      >
        <Route path="/about" element={<components.About />} />
        <Route path="/data" element={<components.Data />} />
        <Route path="/ped" element={<components.Ped />} />
        <Route index element={<Navigate to={URL_TEACHER_MAIN_NEW_ABOUT}/>}/>
      </Route>
    </Routes>
  );
};

export { DashboardNew };
